import WebServiceRequest from '../Api/WebServiceRequest'

class SlideCreateSlideRequest extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('Slide/CreateSlide')
    }
    setData(data){
        super.setFormData(data)
    }
}

class SlideDeleteSlideRequest extends WebServiceRequest {
    constructor (context) {
        super(context)
    }
    setParams(id){
        super.setTag(`Slide/DeleteSlide/${id}`)
    }
}

class SlideGetSlidesRequest extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setMethod('GET')
        super.setTag('Slide/GetSlides')
    }
    setParams(value) {
        super.setRequestParam(value);
    }
}

export {
    SlideCreateSlideRequest,
    SlideDeleteSlideRequest,
    SlideGetSlidesRequest
}